<template>
  <div class="file">
    <div v-if="value" class="file-upload">
      <p class="file-name">
        {{ value.name }}
        <span>{{ Math.round(value.size/1000) }} ko</span>
      </p>
      <button type="button" @click="onRemove" class="file-remove">
        <i class="ic ic-close"></i>
      </button>
    </div>
    <template v-else>
      <button type="button" class="button" @click="onChooseFile" :disabled="progress">
        {{ Translator('soprasolar.claim_request.download_button') }}
        <i class="ic ic-upload" v-if="!progress"></i>
        <span class="button-loader" v-if="progress"></span>
      </button>
    </template>
    <p class="file-error" v-if="error">{{ error }}</p>
  </div>
</template>
<style scoped lang="scss">
  @import "~@/soprasolar-claim/assets/styles/import";
  .button {
    @include cta;
  }
  .file {
    margin-bottom: rem(10);
  }
  .infos {
    margin-top: rem(5);
    font-size: rem(11);
    font-style: italic;
    color: $grey;
  }
  .file-upload {
    display: flex;
    align-items: center;
    gap: rem(10);
  }
  .file-name {
    display: flex;
    align-items: center;
    gap: rem(5);
    span {
      font-size: rem(14);
      color: $color-second;
    }
  }
  .file-remove {
    @include resetBtn;
    width: rem(30);
    height: rem(30);
    display: flex;
    justify-content: center;
    align-items: center;
    color: $color-main;
  }
  .file-error {
    color: $color-error;
    font-size: rem(13);
    margin-top: rem(5);
  }
</style>
<script>
import FileService from '@/soprasolar-claim/services/FileService';
const sizeMax = 15 * 1000 * 1000 // 15Mo
// const types = [
//       'application/pdf', 'application/zip',
//       'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
//       'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
//       'image/png', 'image/jpeg', 'image/gif',
//       'image/x-dwg', 'application/acad'
//       ];
export default {
  name: 'file-upload',
  components: {},
  model: {
    prop: 'value',
    event: 'update'
  },
  props: ['value'],
  data () {
    return {
      progress: false,
      error: null
    }
  },

  computed: {
    propModel: {
      get () { return this.value },
      set (value) {
        this.$emit('update', value)
      },
    },
  },

  created() {
    this.onFileChange = this.onFileChange.bind(this);
    this._file = document.createElement('input');
    this._file.type = 'file';
    this._file.addEventListener('change', this.onFileChange);
  },

  beforeDestroy() {
    this._file.removeEventListener('change', this.onFileChange);
  },

  mounted() {},

  methods: {
    onFileChange(pEvt) {
      this.error = null;
      const file = pEvt.target.files[0];
      this._sendFile(file);
    },

    onRemove() {
      this.propModel = null;
    },

    onChooseFile() {
      this._file.click();
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },

    _sendFile(file) {
      if(!file) return;
      // if(!types.includes(file.type)) {
      //   this.error = window.Translator.trans('soprasolar.claim_request.error_file_types');
      //   return;
      // }
      if(file.size > sizeMax) {
        this.error = window.Translator.trans('soprasolar.claim_request.error_size_max');
        return;
      }
      this.progress = true;
      FileService.send(file).then((datas) => {
        this.propModel = datas;
        this.progress = false;
      }).catch( err => {
        console.error('ERROR', err);
        this.progress = false
      })
    },
  }
};
</script>